import { ItemType } from '../types/common.types';

export const Tabs: ItemType[] = [
	{ key: 0, value: 'All Products in Brand SC' },
	{ key: 1, value: 'Material' },
	{ key: 2, value: 'Product Type' },
	{ key: 3, value: 'Department' },
	{ key: 4, value: 'Certificate & additional documents' },
];

export const LabelGrade: ItemType[] = [
	{ key: 1, value: 'RAS' },
	{ key: 2, value: 'RMS' },
	{ key: 3, value: 'RWS' },
	{ key: 4, value: 'RDS' },
	{ key: 5, value: 'GOTS' },
	{ key: 6, value: 'OCS' },
	{ key: 7, value: 'RCS' },
	{ key: 8, value: 'GRS' },
	{ key: 9, value: 'CCS' },
	{ key: 10, value: 'SFA' },
];

export const ProductStatus: ItemType[] = [
	{ key: 1, value: 'Success' },
	{ key: 2, value: 'Failed' },
];

export const Status: ItemType[] = [
	{ key: 1, value: 'Active' },
	{ key: 2, value: 'Inactive' },
];

export const InScope: ItemType[] = [
	{ key: 1, value: 'Yes' },
	{ key: 2, value: 'No' },
];
